module.exports = __webpack_public_path__ + "static/img/discover3.64e08bc7.jpg";